import React, { useState, useEffect } from 'react';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import PageHeader from '../../../components/PageHeader/PageHeader';

const InsuretypeChangeReport = (props) => {

    const [data, setData] = useState([]);

    const [columns, setColumns] = useState([
        {
            name: 'Дотоод хөдөлгөөний төрөл',
            fieldName: 'shifttypename',
            minColSize: 'mid'
        },
        {
            name: 'Хуулийн этгээд',
            fieldName: 'companyname',
            minColSize: 'mid'
        },
        {
            name: 'Тушаалын дугаар',
            fieldName: 'orderno',
            minColSize: 'mid'
        },
        {
            name: 'Даатгуулагчийн төрөл',
            fieldName: 'insuretypename',
            minColSize: 'mid'
        },
        {
            name: 'Дотоод нэгж',
            fieldName: 'depname',
            minColSize: 'mid'
        },
        {
            name: 'Ажлын байр',
            fieldName: 'positionname',
            minColSize: 'mid'
        },
        {
            name: 'Эхэлсэн огноо',
            fieldName: 'begindate',
            minColSize: 'mid'
        },
        {
            name: 'Дууссан огноо',
            fieldName: 'enddate',
            minColSize: 'mid'
        },
        {
            name: 'Үндсэн цалин',
            fieldName: 'basewage',
            minColSize: 'mid'
        },
        {
            name: 'Хөдөлмөрийн нөхцөл',
            fieldName: 'labourcondition',
            minColSize: 'mid'
        },
        {
            name: 'Нэмэлт мэдээлэл',
            fieldName: 'note'
        }, {
            name: 'Хүйс',
            fieldName: 'empgendername'
        }
    ]);

    const [loading, setLoading] = useState(false);
    const getData = async () => {
        setLoading(true);
        let tData = [];

        tData = [
        ];

        setData(tData);
        setLoading(false);
    };

    useEffect(() => {
        getData();
    }, []);

    const onSearch = (p_data) => {
        setData(p_data);
    }

    const onGridFilterChange = async (p_gridfiltervalue) => {
        getData(p_gridfiltervalue);
    }

    return (
        <div>
            <PageHeader
                title='Даатгуулагчийн төрөл өөрчлөгдсөн'
                columns={columns}
                data={data}
                filteredData={data}
                onSearch={onSearch}
                gridFilter={[]}
                dataCount={data.length}
                onGridFilterChange={onGridFilterChange}
                loading={loading}
            />
            <GridDefaultShimmer
                data={data}
                columns={columns}
                loading={loading}
            />
        </div>
    );
}

export default InsuretypeChangeReport;